import React from 'react';
import {Outlet} from 'react-router-dom';
import Team from './Team';
import History from './History';
import Mission from './Mission';



function AboutUs() {
  return (
    <>
      <Team/>
      <div style={{marginTop:-80}}><History/></div>
      <div style={{marginTop:-80}}><Mission/></div>
      <Outlet/>
    </>

  )
}

export default AboutUs;